var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: '100%', width: '100%' })},[_c('div',{style:({
      height: '100%',
      width: '100%',
      backgroundColor: _vm.isGunmaArea() ? 'rgba(0,0,0,0.2)' : 'none'
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }